(function () {
  const root = document.getElementById('ufc-wine-directory');
  if (!root) return;

  const fallback = root.dataset.fallbackImage;
  const list = root.querySelector('[data-listings]');
  const count = root.querySelector('[data-count]');
  const showing = root.querySelector('[data-showing]');
  const status = root.querySelector('[data-status]');
  const queryInput = root.querySelector('[name="query"]');
  const typeSelect = root.querySelector('[data-filter="type"]');
  const stateSelect = root.querySelector('[data-filter="state"]');
  const featureSelect = root.querySelector('[data-filter="feature"]');
  const layout = root.querySelector('[data-layout]');
  const modal = root.querySelector('[data-modal]');
  const modalContent = root.querySelector('[data-modal-content]');
  let records = [];
  let submittedQuery = '';
  let map;
  let markerLayer;

  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const tagHtml = (values) => `<div class="ufc-tags">${values.map((tag) => `<span>${escapeHtml(tag)}</span>`).join('')}</div>`;

  function matches(item) {
    const haystack = `${item.name} ${item.city} ${item.state} ${item.postalCode}`.toLowerCase();
    const feature = featureSelect.value;
    return (!submittedQuery || haystack.includes(submittedQuery.toLowerCase()))
      && (typeSelect.value === 'All types' || item.types.includes(typeSelect.value))
      && (stateSelect.value === 'All states' || item.state === stateSelect.value)
      && (feature === 'All features' || (feature === 'UrFriendCharles Recommends' ? item.recommended : item.directoryTags.includes(feature)));
  }

  function card(item) {
    const photo = item.photo || fallback;
    const fallbackClass = item.photo ? '' : 'is-fallback';
    return `<article class="ufc-card">
      <img src="${escapeHtml(photo)}" alt="${escapeHtml(item.name)} listing photo" class="${fallbackClass}" data-photo>
      <div><h3>${escapeHtml(item.name)}</h3><p>⌖ ${escapeHtml(item.city)}, ${escapeHtml(item.state)}</p>${tagHtml(item.types.slice(0,3))}<div class="ufc-rating"><b>★</b> ${item.rating || 'New'}${item.reviews ? ` (${Number(item.reviews).toLocaleString()} reviews)` : ''}</div></div>
      <div class="ufc-card-actions"><a href="${escapeHtml(item.googleMapsLink)}" target="_blank" rel="noopener">Directions</a><button type="button" data-details="${escapeHtml(item.id)}">View details</button></div>
    </article>`;
  }

  function renderMap(items) {
    if (!window.L) return;
    if (!map) {
      map = L.map('ufc-directory-map', { scrollWheelZoom: false }).setView([38.5, -96], 4);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '&copy; OpenStreetMap contributors' }).addTo(map);
      markerLayer = L.layerGroup().addTo(map);
    }
    markerLayer.clearLayers();
    items.forEach((item) => L.marker([item.latitude, item.longitude]).bindPopup(`<strong>${escapeHtml(item.name)}</strong><br>${escapeHtml(item.city)}, ${escapeHtml(item.state)}`).addTo(markerLayer));
    map.invalidateSize();
    if (items.length === 1) map.setView([items[0].latitude, items[0].longitude], 11);
    else map.setView([38.5, -96], 4);
  }

  function render() {
    const results = records.filter(matches);
    const visible = results.slice(0, 12);
    count.textContent = `${results.length} locations`;
    showing.textContent = `Showing ${visible.length} of ${results.length}`;
    list.innerHTML = visible.length ? visible.map(card).join('') : '<div style="padding:60px 24px;text-align:center"><h2>No matches yet</h2><p>Try another city or clear a filter.</p></div>';
    list.querySelectorAll('[data-photo]').forEach((image) => image.addEventListener('error', () => { image.src = fallback; image.classList.add('is-fallback'); }, { once: true }));
    renderMap(visible);
  }

  function openDetails(id) {
    const item = records.find((record) => String(record.id) === String(id));
    if (!item) return;
    modalContent.innerHTML = `<div class="ufc-modal-body"><img src="${escapeHtml(item.photo || fallback)}" alt="${escapeHtml(item.name)} listing photo"><div class="ufc-modal-copy"><p class="ufc-eyebrow">${escapeHtml(item.types.join(' · '))}</p><h2>${escapeHtml(item.name)}</h2><p>${escapeHtml(item.address)}</p>${tagHtml(item.directoryTags)}${item.recommended ? '<p><strong>UrFriendCharles Recommends</strong></p>' : ''}<p><b style="color:#ff7e33">★</b> ${item.rating} (${Number(item.reviews).toLocaleString()} reviews)</p><p>✓ Self-identified as Black-owned on Google</p><div class="ufc-modal-links"><a href="${escapeHtml(item.googleMapsLink)}" target="_blank" rel="noopener">Get directions</a>${item.website ? `<a href="${escapeHtml(item.website)}" target="_blank" rel="noopener">Visit website</a>` : ''}</div></div></div>`;
    modal.showModal();
  }

  root.querySelector('[data-directory-search]').addEventListener('submit', (event) => { event.preventDefault(); submittedQuery = queryInput.value.trim(); status.textContent = submittedQuery ? `Showing matches for “${submittedQuery}”` : ''; render(); });
  [typeSelect, stateSelect, featureSelect].forEach((select) => select.addEventListener('change', render));
  root.querySelector('[data-clear]').addEventListener('click', () => { queryInput.value=''; submittedQuery=''; typeSelect.value='All types'; stateSelect.value='All states'; featureSelect.value='All features'; status.textContent='Filters cleared'; render(); });
  root.querySelectorAll('[data-view]').forEach((button) => button.addEventListener('click', () => { const view=button.dataset.view; layout.classList.toggle('is-list', view==='list'); layout.classList.toggle('is-map', view==='map'); root.querySelectorAll('[data-view]').forEach((item) => item.classList.toggle('is-active', item===button)); if(map) setTimeout(()=>map.invalidateSize(),0); }));
  list.addEventListener('click', (event) => { const button=event.target.closest('[data-details]'); if(button) openDetails(button.dataset.details); });
  root.querySelector('[data-modal-close]').addEventListener('click', () => modal.close());

  fetch(root.dataset.directoryUrl).then((response) => response.json()).then((data) => {
    records = data;
    [...new Set(records.map((item) => item.state).filter(Boolean))].sort().forEach((state) => stateSelect.add(new Option(state, state)));
    render();
  }).catch(() => { count.textContent='Directory unavailable'; status.textContent='Please refresh the page or try again later.'; });
})();
